import { Component } from '@angular/core';
import { SsbKonfigSearchComponent } from '@features/ssb-konfig-search/ssb-konfig-search.component';
import { SsbKonfigResultComponent } from '@features/ssb-konfig-result/ssb-konfig-result.component';

@Component({
    selector: 'app-ssb-konfiguration',
  imports: [
    SsbKonfigSearchComponent,
    SsbKonfigResultComponent
  ],
    templateUrl: './ssb-konfiguration.component.html',
    styleUrl: './ssb-konfiguration.component.css'
})
export class SsbKonfigurationComponent {


}
